export default __webpack_public_path__ + "static/media/LAVORICOMPLEMENTARIPERMESSAINSICUREZZABACINODICARENAGGIODA150.000TPL.798a9222.pdf";